export default __webpack_public_path__ + "static/game-theory-mobile-burn-f1a6243339fd4bf1dbf82ac00556f189.svg";